const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SSN[0]"
     },
     docName: {
         value: "",
         dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicense: {
       value : "",
       dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].Page_4[0].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CONDITION1b1[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b1[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CONDITION1b2[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b2[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CONDITION1b3[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b3[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CONDITION1b4[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b4[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CONDITION1b5[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b5[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CONDITION1b6[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b6[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CONDITION1b7[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b7[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CONDITION1b8[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b8[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CONDITION1b9[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b9[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CONDITION1b10[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b10[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CONDITION1b11[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b11[0]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].#subform[1].CONDITION1b12[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b12[0]",
        },        
        {
            type: "text",
            dbqName: "F[0].#subform[1].diagnosis1b1[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b13[0]",
        },
        {
            type: "text",
            dbqName: "F[0].#subform[1].diagnosis1b2[0]",
            dateDbqName: "F[0].#subform[1].Dateofdiagnosis1b14[0]",
        },        
    ]

}

export default ssn ;